/**
 * Javascript for translations of psr_shop.
 * Product Owner: Raphael Wälterlin <raphael.waelterlin@cabag.ch>
 * Author: Markus Gehrig <markus.gehrig@cabag.ch>
 * Date: 15. Apr 2019
 * 
 * Customer: Prospecia Rara
 * Company: cab services ag
 */

/**
 * Load external JavaScript Libaries
 */



var messages = {
    de: {
        "basket":           "Warenkorb",
        "into-basket":      "In den Warenkorb",
        "basket-help":      "zum Warenkorb hinzufügen",
        "sum-total":        "Gesamtsumme",
        "sumtotal":         "Gesamtsumme",
        "price":            "Preis",
        "quantity":         "Anzahl",
        "checkout":         "Zur Kasse",
        "description":      "Beschreibung",
        "highlights":       "Steckbrief",
        "order":            "Bestellung",
        "back":             "Zurück",
        "remove":           "Artikel entfernen",
        "shop":             "Shop",
        "readmore":         "Mehr lesen",
        "available":        "verfügbar",
        "notavailable":     "nicht verfügbar",
        "amount":           "Anzahl:",
        "porto":            "zzgl. Versandkosten",
        "portoAdditional":	" (bitte beachten Sie die Angaben bei den einzelnen Artikeln)",
        "article":          "Artikel",
        "tab-description":  "Beschrieb ",
        "tab-highlights":   "Steckbrief",
        "tab-order":        "Versandkosten",
        "all-infos":        "Das Wichtigste auf einen Blick",
        "filterAll":        "Alle",
        'product-added-to-filter': "Das Produkt wurde dem Warenkorb hinzugefügt.",
        'product-added-to-filter-noquantity': "Das Produkt wurde dem Warenkorb nicht hinzugefügt. Die Anzahl darf nicht weniger als 1 sein.", 
        'vat':              "zzgl. MWST"
    },
    en: {
        "basket":           "EN: Warenkorb",
        "into-basket":      "EN: In den Warenkorb",
        "basket-help":      "EN: zum Warenkorb hinzufügen",
        "sum-total":        "EN: Gesamtsumme",
        "sumtotal":         "EN: Gesamtsumme",
        "price":            "EN: Preis",
        "quantity":         "EN: Anzahl",
        "checkout":         "EN: Zur Kasse",
        "description":      "EN: Beschreibung",
        "highlights":       "EN: Steckbrief",
        "order":            "EN: Order",
        "back":             "EN: Back",
        "remove":           "EN: Artikel entfernen",
        "shop":             "EN: Shop",
        "readmore":         "EN: Mehr lesen",
        "available":        "EN: verfügbar",
        "notavailable":     "EN: nicht verfügbar",
        "amount":           "EN: Anzahl:",
        "porto":            "EN: zzgl. Versandkosten",
        "portoAdditional":	"EN: (bitte beachten Sie die Angaben bei den einzelnen Artikeln)",
        "article":          "EN: Artikel",
        "tab-description":  "EN: Beschrieb ",
        "tab-highlights":   "EN: Steckbrief",
        "tab-order":        "EN: Bestellung",
        "all-infos":        "EN: Das wichtigste auf einen Blick",
        "filterAll":        "EN: Alle",
        'product-added-to-filter': "The product has been added to the shopping cart.",
        'product-added-to-filter-noquantity': "The product has not been added to the shopping cart. Can't add 0x of a product.",
        'vat':              "EN: zzgl. MWST"
    },
    fr: {
        "basket":           "Panier",
        "into-basket":      "Dans le panier",
        "basket-help":      "Ajouter au panier",
        "sum-total":        "Total",
        "sumtotal":         "Total",
        "price":            "Prix",
        "quantity":         "Nombre",
        "checkout":         "Aller à la caisse",
        "description":      "Description",
        "highlights":       "Fiche descriptive",
        "order":            "Commande",
        "back":             "Retour",
        "remove":           "Retirer l'article",
        "shop":             "Shop",
        "readmore":         "En savoir plus",
        "available":        "Disponible",
        "notavailable":     "Non disponible",
        "amount":           "Nombre",
        "porto":            "Plus frais d'expédition",
        "portoAdditional":	"",
        "article":          "Article",
        "tab-description":  "Descriptif ",
        "tab-highlights":   "Fiche descriptive",
        "tab-order":        "Commande",
        "all-infos":        "L'essentiel en un coup d'œil",
        "filterAll":        "Tous",
        'product-added-to-filter': "Le produit a été ajouté au panier d'achat",
        'product-added-to-filter-noquantity': "Le produit n'a pas été ajouté au panier. La quantité ne doit pas être inférieure à 1.",
        'vat':              "hors TVA"
    },
    it: {
        "basket":           "Carrello",
        "into-basket":      "Metti nel carrello",
        "basket-help":      "Aggiungi al carrello",
        "sum-total":        "Totale",
        "sumtotal":         "Totale",
        "price":            "Prezzo",
        "quantity":         "Quantità",
        "checkout":         "Alla cassa",
        "description":      "Descrizione",
        "highlights":       "Scheda",
        "order":            "Ordinazione",
        "back":             "Indietro",
        "remove":           "Rimuovi articolo",
        "shop":             "Shop",
        "readmore":         "di più",
        "available":        "disponibile",
        "notavailable":     "non disponibile",
        "amount":           "Quantità:",
        "porto":            "più spese di spedizione",
        "portoAdditional":	"",
        "article":          "Articolo",
        "tab-description":  "Descrizione ",
        "tab-highlights":   "Scheda",
        "tab-order":        "Ordinazione",
        "all-infos":        "L'essenziale in sintesi",
        "filterAll":        "Tutti",
        'product-added-to-filter': "Il prodotto è stato aggiunto al carrello",
        'product-added-to-filter-noquantity': "Il prodotto non è stato aggiunto al carrello. La quantità non deve essere inferiore a 1.",
        'vat':              "IVA esclusa"
    }
};

//var sys_language_id = window.lang;
var lang = $('html').attr('lang');

function getTranslation(key) {
    return (messages[lang] || messages['de'])[key] || '';
}

function currencyFormatter( price ) {
    return price.toFixed(2);
}

module.exports = {
    getTranslation,
    currencyFormatter
}
